import PropTypes from 'prop-types';
import React from 'react';

class MobileInputDropdownMultiple extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedValues: [],
        };

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(e) {
        const selectedValuesIndexes = [];
        [...e.target.options].forEach((item, key) => {
            if (item.selected) selectedValuesIndexes.push(key);
        });

        this.setState(
            {
                // We need to [index - 1] here since the first element will always be the default value!
                selectedValues: selectedValuesIndexes.map((index) => this.props.options[index - 1]),
            },
            () => {
                this.props.onChange(this.state.selectedValues);
            }
        );
    }

    render() {
        const options = this.props.options.map((option) => {
            return (
                <option key={`mobile-${option.value}`} value={option.value} selected={option.selected}>
                    {option.label}
                </option>
            );
        });

        const shouldSelectDefault = !this.state.selectedValues.length;

        return (
            <select
                multiple
                onChange={this.handleOnChange}
                className={this.props.classNames.join(' ')}
                name={this.props.name}
            >
                <option value="default" selected={shouldSelectDefault} disabled>
                    {this.props.defaultSelectionPlaceholder}
                </option>
                {options}
            </select>
        );
    }
}

MobileInputDropdownMultiple.defaultProps = {
    classNames: [],
    name: '',
};

MobileInputDropdownMultiple.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            selected: PropTypes.bool.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    defaultSelectionPlaceholder: PropTypes.string.isRequired,
    classNames: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
};

export default MobileInputDropdownMultiple;



// WEBPACK FOOTER //
// ./src/components/InputDropDown/MobileInputDropDownMultiple.jsx